import { render, staticRenderFns } from "./selectYear.vue?vue&type=template&id=2a144cc2&scoped=true&"
import script from "./selectYear.vue?vue&type=script&lang=js&"
export * from "./selectYear.vue?vue&type=script&lang=js&"
import style0 from "./selectYear.vue?vue&type=style&index=0&id=2a144cc2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a144cc2",
  null
  
)

export default component.exports